/* eslint-disable import/no-unassigned-import */
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.repeat';
import 'core-js/modules/es.string.starts-with';
import 'core-js/modules/es.string.ends-with';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.array.from';
import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.find-index';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.promise';
import 'core-js/modules/es.set';
import 'core-js/modules/es.map';
import 'core-js/modules/es.symbol';
/* eslint-enable import/no-unassigned-import */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { Provider as MobxProvider } from 'mobx-react';
import { parse } from 'query-string';

import { IConfig, DEFAULT_CONFIG, setConfig, setLocales } from '@constants';

import { EPlatform } from '@enums';

import { Log, setAccessToken, setPlatform } from '@utils';

import { getStore } from '@redux';

import { getState, resetState, parseInitialState } from '@mobx';

import { Api } from '@api';
import { BrowserHttpTransport } from '@api/BrowserHttpTransport';

import { App } from './App';

// eslint-disable-next-line import/no-unassigned-import
import './styles/common.scss';

const store = getStore();
const root = document.getElementById('root');
const isEmptyRoot = !root || !root.innerHTML || String(root.innerHTML).length === 0;
const render = isEmptyRoot ? ReactDOM.render.bind(ReactDOM) : ReactDOM.hydrate.bind(ReactDOM);
let CONFIG: IConfig = DEFAULT_CONFIG;

try {
	CONFIG = JSON.parse(document.getElementById('app-config').innerHTML);

	setConfig(CONFIG);
	setPlatform(CONFIG.isAndroid ? EPlatform.ANDROID : CONFIG.isIOs ? EPlatform.IOS : EPlatform.UNKNOWN);
} catch (err) {
	Log.error('FAILED PARSE APP CONFIG');
}

try {
	setLocales(JSON.parse(document.getElementById('app-locales').innerHTML));
} catch (err) {
	Log.error('FAILED PARSE APP LOCALES');
}

BrowserHttpTransport.setup();
Api.setTransport(BrowserHttpTransport);

resetState();
parseInitialState();
const stores = getState();

window._____APP_STATE_____ = stores;

const { token } = parse(window.location.hash.replace(/^#/, ''));

setAccessToken(token as string);

const renderApp = () => {
	render(
		<MobxProvider {...stores}>
			<Provider store={store} {...stores}>
				<BrowserRouter
					basename={CONFIG.isLocalServer ? `/${CONFIG.subProject}` : '/'}
				>
					<App/>
				</BrowserRouter>
			</Provider>
		</MobxProvider>,
		root,
	);
};

const initApp = () => {
	if (CONFIG.isServerRendering || CONFIG.isError502) {
		renderApp();
	} else {
		try {
			/* render app */
			renderApp();
		} catch (err) {
			Log.error('FAILED FETCH CURRENT USER');
			Log.message('Clear localStorage');

			renderApp();
		}
	}
};

void initApp();
